import { render, staticRenderFns } from "./clientsmodal.vue?vue&type=template&id=9e1ccb18"
import script from "./clientsmodal.vue?vue&type=script&lang=js"
export * from "./clientsmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports